import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { GasIcon } from '../../utils/gas-icons/icon/gas-icon.namespace';
import { GasMicroButton } from './gas-micro-button.namespace';

const ICON_SIZES = {
  small: 12,
  large: 16,
};

@Component({
  selector: 'gas-micro-button',
  templateUrl: './gas-micro-button.component.html',
  styleUrls: ['./gas-micro-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasMicroButtonComponent {
  @Input()
  public type: GasMicroButton.Type | string = GasMicroButton.Type.Optional;

  @Input()
  public set size(userSize: GasMicroButton.Size | string) {
    if (userSize) {
      this.iconSize = userSize === GasMicroButton.Size.Small ? ICON_SIZES.small : ICON_SIZES.large;
      this.isLarge = userSize === GasMicroButton.Size.Large;
    }
  }

  @HostBinding('class._disabled')
  @Input()
  public disabled = false;

  @Input()
  public iconName: GasIcon.Icons | string = GasIcon.Arrows.ChevronRight;

  @HostBinding('class._large')
  public isLarge = false;

  public iconSize = ICON_SIZES.small;

  @HostBinding('class._primary')
  public get primaryClass(): boolean {
    return this.type === GasMicroButton.Type.Primary;
  }

  @HostBinding('class._secondary')
  public get secondaryClass(): boolean {
    return this.type === GasMicroButton.Type.Secondary;
  }

}
